import { Injectable } from '@angular/core';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { AbstractService } from "@services/abstract.service";
import { LocationClass } from "@classes/location.class";

@Injectable({providedIn: 'root'})
export class LocationService extends AbstractService {
  constructor(
    public customHttpService: CustomHttpService,
  ) {
    super(customHttpService, new LocationClass());
    this.version = 'v1';
  }

  public uploadFile = (uploadFile: any) => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(
          true,
          true,
          url + this.modelClass.modelName + '/CreateLocationsBash',
          uploadFile,
          null
        ).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }
}
